import { createClient } from "@supabase/supabase-js";

const url = process.env.VUE_APP_SUPABASE_URL;
const key = process.env.VUE_APP_SUPABASE_KEY;

// null si falten les variables d'entorn: l'app mostra un missatge en lloc de petar
export const supabase =
    url && key ? createClient(url, key, { auth: { persistSession: false } }) : null;
